import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import * as NotificationActions from './notification.actions';
import { APIService } from '../../services/api/api.service';

@Injectable()
export class NotificationEffects {
  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.loadNotifications),
      switchMap(() =>
        this.apiService.getAdminNotifications().pipe(
          map(notifications =>
            NotificationActions.loadNotificationsSuccess({ notifications })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error loading notifications.');
            return of(NotificationActions.loadNotificationsFailure({ error }));
          })
        )
      )
    )
  );

  dismissAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.dismissAll),
      switchMap(() =>
        this.apiService.dismissAllNotifications().pipe(
          map(() => NotificationActions.dismissAllSuccess()),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error marking all notifications as read.');
            return of(NotificationActions.dismissAllFailure({ error }));
          })
        )
      )
    )
  );

  dismissSingle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.dismissSingle),
      switchMap(action =>
        this.apiService.dismissSingleNotification(action.notificationId).pipe(
          map(() =>
            NotificationActions.dismissSingleSuccess({ notificationId: action.notificationId })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error marking notifications as read.');
            return of(NotificationActions.dismissSingleFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private apiService: APIService,
    private notification: NzNotificationService
  ) { }
}
